import {connect} from 'react-redux';
import {ExperimentPoster as Component} from './ExperimentPoster';
import {
  createExperimentPoster,
  setModal,
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("experimentPoster") &&
     state.notebook.protocolSection.scene.apparatus.experimentPoster.some(
       poster => poster.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.experimentPoster[ownProps.id-1].type
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createExperimentPoster: (data)=>{
      dispatch(createExperimentPoster(data))
    },
    setModal: (data)=>{
      dispatch(setModal(data))
    },
    showModal: (data)=>{
      dispatch(showModal(data))
    },
  };
}

export const ExperimentPoster = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
